import { LEADERBOARD } from '@/game/constants';

export type ValidationError = 'empty' | 'too-short' | 'too-long' | 'profanity' | 'invalid-chars';

export interface ValidationResult {
  ok: boolean;
  error?: ValidationError;
  message?: string;
}

const MIN = LEADERBOARD.MIN_DISPLAY_NAME_LENGTH;
const MAX = LEADERBOARD.MAX_DISPLAY_NAME_LENGTH;

const PROFANITY_BLOCKLIST_V0: readonly string[] = [
  'fuck',
  'shit',
  'bitch',
  'cunt',
  'nigger',
  'nigga',
  'faggot',
  'retard',
  'slut',
  'whore',
];

const ALLOWED_CHARS = /^[A-Za-z0-9 _.\-]+$/;

export function containsProfanity(name: string): boolean {
  const lower = name.toLowerCase();
  return PROFANITY_BLOCKLIST_V0.some((word) => lower.includes(word));
}

export function validateUsername(raw: string): ValidationResult {
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return { ok: false, error: 'empty', message: 'Pick a name to submit.' };
  }
  if (trimmed.length < MIN) {
    return { ok: false, error: 'too-short', message: `At least ${MIN} characters.` };
  }
  if (trimmed.length > MAX) {
    return { ok: false, error: 'too-long', message: `At most ${MAX} characters.` };
  }
  if (!ALLOWED_CHARS.test(trimmed)) {
    return {
      ok: false,
      error: 'invalid-chars',
      message: 'Letters, numbers, space, dot, dash, underscore only.',
    };
  }
  if (containsProfanity(trimmed)) {
    return { ok: false, error: 'profanity', message: 'Pick a different name.' };
  }
  return { ok: true };
}

export const SANITY_BAND_MAX_PER_SECOND = 100_000;

export function passesSanityBand(score: number, playTime: number): boolean {
  if (score <= 0 || playTime <= 0) return false;
  return score <= playTime * SANITY_BAND_MAX_PER_SECOND;
}
